<template>
  <div class="container">
    <div class="container__content">
      <div class="container__content-logo">
        <img src="../assets/LOGO_HANSA_MONOCHROM_haushaltsgerate P199.png" />
      </div>
      <div class="container__content-article">
        <p>
          Website under construction. We appreciate your patience<br />
          and apologize for any inconvenience. Please come back soon.
        </p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://amica-group.com/"
          >Visit Amica Group Site &raquo;</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HansaTemporaryView",
  methods: {
    onBtnClick: function() {
      this.checkData = !this.checkData;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// * {
//   background-color: rgba(255, 0, 0, 0.2);
// }
// * * {
//   background-color: rgba(0, 255, 0, 0.2);
// }
// * * * {
//   background-color: rgba(0, 0, 255, 0.2);
// }
// * * * * {
//   background-color: rgba(255, 0, 255, 0.2);
// }
// * * * * * {
//   background-color: rgba(0, 255, 255, 0.2);
// }
// * * * * * * {
//   background-color: rgba(255, 255, 0, 0.2);
// }
// * * * * * * * {
//   background-color: rgba(255, 0, 0, 0.2);
// }
// * * * * * * * * {
//   background-color: rgba(0, 255, 0, 0.2);
// }
// * * * * * * * * * {
//   background-color: rgba(0, 0, 255, 0.2);
// }
.container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url("../assets/zaslepka_Hansa.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-family: "FreeSet";

  .container__content {
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.05);
    background: -moz-linear-gradient(
      left,
      rgba(255, 255, 255, 0.05) 0%,
      rgba(255, 255, 255, 0.72) 20%,
      rgba(255, 255, 255, 0.72) 50%,
      rgba(255, 255, 255, 0.72) 80%,
      rgba(255, 255, 255, 0.05) 100%
    );
    background: -webkit-gradient(
      left top,
      right top,
      color-stop(0%, rgba(255, 255, 255, 0.05)),
      color-stop(20%, rgba(255, 255, 255, 0.72)),
      color-stop(50%, rgba(255, 255, 255, 0.72)),
      color-stop(80%, rgba(255, 255, 255, 0.72)),
      color-stop(100%, rgba(255, 255, 255, 0.05))
    );
    background: -webkit-linear-gradient(
      left,
      rgba(255, 255, 255, 0.05) 0%,
      rgba(255, 255, 255, 0.72) 20%,
      rgba(255, 255, 255, 0.72) 50%,
      rgba(255, 255, 255, 0.72) 80%,
      rgba(255, 255, 255, 0.05) 100%
    );
    background: -o-linear-gradient(
      left,
      rgba(255, 255, 255, 0.05) 0%,
      rgba(255, 255, 255, 0.72) 20%,
      rgba(255, 255, 255, 0.72) 50%,
      rgba(255, 255, 255, 0.72) 80%,
      rgba(255, 255, 255, 0.05) 100%
    );
    background: -ms-linear-gradient(
      left,
      rgba(255, 255, 255, 0.05) 0%,
      rgba(255, 255, 255, 0.72) 20%,
      rgba(255, 255, 255, 0.72) 50%,
      rgba(255, 255, 255, 0.72) 80%,
      rgba(255, 255, 255, 0.05) 100%
    );
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.05) 0%,
      rgba(255, 255, 255, 0.72) 20%,
      rgba(255, 255, 255, 0.72) 50%,
      rgba(255, 255, 255, 0.72) 80%,
      rgba(255, 255, 255, 0.05) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff', GradientType=1 );
    margin-top: 5%;
    padding: 2%;
    padding-bottom: 5%;
    .container__content-logo {
      display: flex;
      width: 100%;
      justify-content: flex-end;
      padding-right: 2%;
      img {
        width: 12rem;
      }
    }
    .container__content-article {
      display: flex;
      width: 100%;
      flex-direction: column;
      text-align: justify;

      p {
        margin: 0;
        margin-bottom: 20px;
        font-size: 1.2rem;
      }
      a {
        text-decoration: none;
        color: black;
      }
    }
  }
}
@media (max-width: 1200px) {
  .container {
    justify-content: center;
    .container__content {
      flex-direction: column;
      .container__content-logo {
        justify-content: center;
        padding-bottom: 1rem;
        padding-top: 1rem;
      }
      .container__content-article {
        text-align: center;
      }
    }
  }
}
</style>
